import { language, serviceCode, suggestServiceCode, apiUrl, setCookie, getCookie, deleteCookie, getHash, useCookie } from './utils';
import { l10n } from './l10n';

const serviceCookie = `${serviceCode}-search-recent-keyword-v2`;
let cookie = getCookie(serviceCookie);
let cookieArray = cookie && cookie.split(',') || [];
let isRecent = false;


export function createSearch () {
  insertDom();
  addEvent();
}

function insertDom () {
  const $dom = $('#ncGuidebookSearch');
  const { search } = window.guidebook;

  if (!$dom.length || !search.use) return false;

  let placeholder = '';
  if (serviceCode === 'l2') {
    placeholder = 'search.placeholder.l2';
  } else if (serviceCode === 'l2awkn') {
    placeholder = 'search.placeholder.l2awkn';
  } else {
    placeholder = 'search.placeholder';
  }

  $dom.append(`
    <div class="ncgb-container">
      <section class="ncgb-searchform">
        <h2 class="ncgb-searchform-title">${l10n('search.title', language)}</h2>
        <form id="ncgbAutoSuggest" class="ncgb-autoSuggest" method="get" action="" onsubmit="return false">
          <input id="ncgbSuggestInput" class="ncgb-suggest-input" type="text" value="" placeholder="${l10n(placeholder, language)}" autocomplete="off" data-name="suggest_input">
          <input type="button" value="X" class="ncgb-suggest-delete" title="${l10n('search.reset', language)}" data-name="suggest_delete">
          <input id="ncgbSuggestSubmit" class="ncgb-suggest-submit" type="button" value="GO" title="${l10n('search.submit', language)}" data-name="suggest_submit">
          <div id="ncgbSuggestWrap" class="ncgb-suggest-list-wrap" data-name="suggest_wrap" style="display: none;">
            <div class="ncgb-suggest-list" data-name="suggest_list" style="display: none;">
              <div data-name="suggest_scroll">
                <ul></ul>
              </div>
            </div>
            <div class="ncgb-suggest-recent" data-name="suggest_recent" style="display: none;">
              <div data-name="suggest_scroll">
                <ul></ul>
                <div class="ncgb-suggest-recent-none">${l10n('search.none', language)}</div>
              </div>
              <div class="ncgb-suggest-recent-btn-wrap">
                <button type="button" class="ncgb-suggest-recent-btn">${l10n('search.clear', language)}</button>
              </div>
            </div>
          </div>
        </form>
      </section>
    </div>
  `);

  switch (search.page) {
    case 'index':
      $dom.addClass('nc-guidebook-search ncgbi-search-top');
      $dom.find('.ncgb-container').wrapInner('<div class="ncgbi-container"></div>');
      break;
    case 'view':
      $dom.addClass('nc-guidebook-search ncgbt-search-top');
      $dom.find('.ncgb-container').prepend(`<a class="ncgb-btn-list" href="guide">${l10n('search.list', language)}</a>`);
      break;
    default:
      $dom.addClass('nc-guidebook-search ncgbs-search-top');
  }

  if (search.page === 'index' && search.ranking) {
    $dom.find('.ncgbi-container').prepend(`
      <section class="ncgb-keyword">
        <h2 class="ncgb-keyword-title">${l10n('search.popular', language)}</h2>
        <button class="ncgb-keyword-toggle"></button>
        <div class="ncgb-keyword-rolling">
          <ol class="ncgb-keyword-list">
            <li>
              <a href="view?title=검색어1"><span class="num">1</span>검색어1</a>
              <span class="ncgb-rank ncgb-rank-same">10</span>
            </li>
            <li>
              <a href="view?title=검색어2"><span class="num">2</span>검색어2</a>
              <span class="ncgb-rank ncgb-rank-same">20</span>
            </li>
          </ol>
        </div>
        <div class="ncgb-keyword-list-wrap">
          <ol class="ncgb-keyword-list">
            <li>
              <a href="view?title=검색어1"><span class="num">1</span>검색어1</a>
              <span class="ncgb-rank ncgb-rank-same">0</span>
            </li>
          </ol>
        </div>
      </section>
    `);

    /*
    const $list = $('.ncgb-keyword .ncgb-keyword-list');

    data.forEach((item, index) => {
      const { title, rank } = item;

      $(`<li>
        <a href="view?title=${title}"><span class="num">${index + 1}</span>${title}</a>
        <span class="ncgb-rank ncgb-rank-same">${rank}</span>
      </li>`)
    });
     */

    $('.ncgb-keyword-rolling, .ncgb-keyword-list-wrap').find('a').on('click', function (event) {
      event.preventDefault();

      runSearch($(this).contents()[1].nodeValue);
    });

    const $list = $('.ncgb-keyword-rolling .ncgb-keyword-list');

    if ($list.find('li').length) {
      setInterval(() => {
        $list.animate({ top: -37 }, 500, () => {
          $list.find('li').eq(0).appendTo($list);
          $list.css({ top: 0 });
        });
      }, 5000);
    }
  }
}

function addEvent () {
  const $keywordInput = $('#ncgbSuggestInput');
  const $keywordWrap = $('#ncgbSuggestWrap');
  const $keywordSubmit = $('.ncgb-suggest-submit');
  const $keywordDelete = $('.ncgb-suggest-delete').hide();
  const $suggest = $('.ncgb-suggest-list');
  const $suggestList = $suggest.find('ul');
  const $recent = $('.ncgb-suggest-recent');
  const $recentList = $recent.find('ul');
  const $recentBtnWrap = $('.ncgb-suggest-recent-btn-wrap');
  const $recentBtn = $recentBtnWrap.find('.ncgb-suggest-recent-btn');
  const $ranking = $('.ncgb-keyword');
  const $rankingBtn = $ranking.find('.ncgb-keyword-toggle');

  let keyAllow = true;
  let keyIndex = -1;

  $keywordInput.on({
    focus () {
      $('.ncgb-dropdown-wrapper').removeClass('is-active');

      setTimeout(() => {
        if (this.value) {
          isRecent = false;
          getSuggest(this.value);
        } else {
          getRecent();
        }
      }, 100);
    },
    input (event) {
      if (event.target.value.length) {
        setTimeout(() => {
          if (event.target.value){
            isRecent = false;
            getSuggest(event.target.value);
          }
        }, 50);
      } else {
        getRecent();
      }
    },
    blur () {
      setTimeout(() => {
        keyIndex = -1;
        isRecent = false;
        $keywordWrap.hide();
      }, 200);
    },
    keydown (event) {
      if (keyAllow) {
        keyAllow = false;

        if (event.key === 'ArrowDown' || event.key === 'Down') {
          if (++keyIndex > $suggestList.find('li').length - 1) keyIndex = 0;
        } else if (event.key === 'ArrowUp' || event.key === 'Up') {
          if (--keyIndex < 0) keyIndex = $suggestList.find('li').length - 1;
        }
      }
    },
    keyup () {
      setTimeout(() => {
        keyAllow = true;

        if (keyIndex > -1) $suggestList.find('li').eq(keyIndex).addClass('focus').siblings().removeClass('focus');
      }, 50);
    },
    keypress (event) {
      const keyword = event.target.value.trim();

      if (event.key === 'Enter') {
        if (!keyword) {
          //alert('검색어를 입력해주세요.');
          // alert(`${l10n('search.alert.none', language)}`);
          if (window.ncui && window.ncui.modal) {
            const ncuiAlert = new window.ncui.modal.uiAlert();
            ncuiAlert
              .open({
                title: `${l10n('search.alert.none', language)}`,
              })
              .then((result) => {
                console.log(result);
              });
          }
          return false;
        }

        if (
          keyword.includes('#') ||
          keyword.includes('&') ||
          keyword.includes('^') ||
          keyword.includes('=') ||
          keyword.includes('[') ||
          keyword.includes(']') ||
          keyword.includes('{') ||
          keyword.includes('}') ||
          keyword.includes('\\') ||
          keyword.includes('|') ||
          keyword.includes('%') ||
          keyword.includes(';') ||
          keyword.includes(',') ||
          keyword.includes('?')||
          keyword.includes('<')||
          keyword.includes('>')
        ) {
          // 추천검색어 API     # &
          // 검색 API           # ^ & = [ ] { } \ |
          // 자바스크립트       % ; , ?
          // alert('사용할 수 없는 검색어가 포함되어 있습니다. (# & ^ = [ ] { } \\ | % ; , ?)');
          // alert(`${l10n('search.alert.unavailable', language)}`);
          if (window.ncui && window.ncui.modal) {
            const ncuiAlert = new window.ncui.modal.uiAlert();
            ncuiAlert
              .open({
                title: `${l10n('search.alert.unavailable', language)}`,
              })
              .then((result) => {
                console.log(result);
              });
          }
          return false;
        }

        if (keyIndex > -1) {
          $keywordInput.val($suggestList.find('li').eq(keyIndex).text());
          keyIndex = -1;
          $suggestList.find('li').removeClass('focus');
        } else {
          runSearch(keyword);
        }
      }
    }
  }).trigger('blur');

  $keywordDelete.on('click', function () {
    $keywordInput.val('');
    setTimeout(() => {
      isRecent = false;
      $keywordInput.focus();
    }, 100);
  });

  $recentBtn.on('click', function () {
    cookie = null;
    cookieArray = [];
    deleteCookie(serviceCookie);
    isRecent = false;
    $recentList.empty();
    $recentBtnWrap.hide();

    setTimeout(() => {
      $keywordInput.focus();
    }, 150);
  });

  $keywordSubmit.on('click', function () {
    const keyword = $keywordInput.val();
    if (
      keyword.includes('#') ||
      keyword.includes('&') ||
      keyword.includes('^') ||
      keyword.includes('=') ||
      keyword.includes('[') ||
      keyword.includes(']') ||
      keyword.includes('{') ||
      keyword.includes('}') ||
      keyword.includes('\\') ||
      keyword.includes('|') ||
      keyword.includes('%') ||
      keyword.includes(';') ||
      keyword.includes(',') ||
      keyword.includes('?')||
      keyword.includes('<')||
      keyword.includes('>')
    ) {
      // 추천검색어 API     # &
      // 검색 API           # ^ & = [ ] { } \ |
      // 자바스크립트       % ; , ?
      // alert('사용할 수 없는 검색어가 포함되어 있습니다. (# & ^ = [ ] { } \\ | % ; , ?)');
      // alert(`${l10n('search.alert.unavailable', language)}`);
      if (window.ncui && window.ncui.modal) {
        const ncuiAlert = new window.ncui.modal.uiAlert();
        ncuiAlert
          .open({
            title: `${l10n('search.alert.unavailable', language)}`,
          })
          .then((result) => {
            console.log(result);
          });
      }
      return false;
    }
    if (keyword) {
      runSearch(keyword);
    } else {
      // alert(`${l10n('search.alert.none', language)}`);

      if (window.ncui && window.ncui.modal) {
        const ncuiAlert = new window.ncui.modal.uiAlert();
        ncuiAlert
          .open({
            title: `${l10n('search.alert.none', language)}`,
          })
          .then((result) => {
            console.log(result);
          });
      }
    }
  });

  $rankingBtn.on('click', function () {
    $ranking.toggleClass('on');
  });

  // 추천 검색어
  function getSuggest (value) {
    const $keywordWrap = $('#ncgbSuggestWrap');
    const $suggest = $('.ncgb-suggest-list');
    const $suggestList = $suggest.find('ul');
    const $recent = $('.ncgb-suggest-recent');
    const $recentNone = $('.ncgb-suggest-recent-none');
    const $keywordDelete = $('.ncgb-suggest-delete');

    $recent.hide();
    $recentNone.hide();
    $keywordDelete.show();

    let _serviceCode = '';

    if (suggestServiceCode) {
      _serviceCode = suggestServiceCode;
    } else {
      _serviceCode = serviceCode;
      // if (serviceCode === 'lineage2m') { // Todo: 레거시
      //   _serviceCode = 'l2m';
      // } else if (serviceCode === 'l2') {
      //   _serviceCode = 'lineage2';
      // } else {
      //   _serviceCode = serviceCode;
      // }
    }

    const regExpValue = value.replace(/(<([^>]+)>)/ig, '').replace(/^#+/g,'');

    if (!regExpValue) return false;

    $.ajax({
      method: 'GET',
      dataType: 'json',
      cache: false,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      url: `${apiUrl}/${_serviceCode}/search/suggest?keyword=${encodeURI(regExpValue)}&size=5`
    }).done((keywordResult) => {
      if(isRecent)return;
      const keywordArray = keywordResult.searchHits;

      if (!keywordArray.length) {
        $keywordWrap.hide();

        return false;
      }

      $suggestList.empty();

      keywordArray.forEach((item) => {
        const keyword = item.keyword.replace(value, '<mark>' + value + '</mark>');
        const $li = $('<li>' + keyword + '</li>').on('click', function () {
          runSearch(item.keyword);
        });

        $suggestList.append($li);
      });

      $suggest.show();
      $keywordWrap.show();
    });
  }

  // 최근 검색어
  function getRecent () {
    if(!useCookie)return;
    isRecent = true;
    cookie = getCookie(serviceCookie);
    cookieArray = cookie && cookie.split(',') || [];

    const $keywordWrap = $('#ncgbSuggestWrap');
    const $suggest = $('.ncgb-suggest-list');
    const $suggestList = $suggest.find('ul');
    const $recent = $('.ncgb-suggest-recent');
    const $recentList = $recent.find('ul').empty();
    const $recentBtnWrap = $('.ncgb-suggest-recent-btn-wrap');
    const $recentNone = $('.ncgb-suggest-recent-none');
    const $keywordDelete = $('.ncgb-suggest-delete');

    $suggestList.empty();
    $keywordDelete.hide();
    $recentNone.hide();

    $recent.show();
    $keywordWrap.show();

    if (!cookie) {
      $recentBtnWrap.hide();
      $recentNone.show();

      return false;
    } else {
      $recentBtnWrap.show();
    }

    cookieArray.slice(0, 5).forEach((keyword) => {
      const $li = $(`<li>${keyword}<input type="button" value="X" class="ncgb-suggest-recent-delete" title="${l10n('search.delete', language)}"></li>`).on('mousedown', function (event) {
        const targetKeyword = $(this).text();

        if (event.target.tagName === 'LI') { // 키워드 클릭
          runSearch(targetKeyword);
        } else if (event.target.tagName === 'INPUT') { // 삭제 클릭
          cookieArray.some((keyword, index) => {
            if (targetKeyword === keyword) {
              cookieArray.splice(index, 1);
              return true;
            }
          });

          setCookie(serviceCookie, cookieArray.join(','));

          if ($(this).siblings('li').length === 0) {
            $recentBtnWrap.hide();
            $recentNone.show();
          }

          $(this).remove();
        }
      });

      $recentList.append($li);
    });
  }

  const $window = $(window);
  const $index = $('#ncGuidebookIndex');
  const $search = $('#ncGuidebookSearch');
  const $block = $('<div></div>').height($search.outerHeight(true)).hide().insertAfter($search);
  const searchOffsetTop = $search.offset().top;

  const $tab = $('.module-tab');
  const hasTab = $tab.length;
  const tabHeight = $tab.height();

  // $window.on('scroll', function () {
  //   if ($window.width() < 960) { // 모바일
  //     if (hasTab) { // 리니지2 탭때문에 ㅠㅠ
  //       if ($index.length && $window.scrollTop() > tabHeight) { // 메인
  //         $search.addClass('is-sticky');
  //         $block.show();
  //       } else {
  //         $search.removeClass('is-sticky');
  //         $block.hide();
  //       }
  //     } else {
  //       if ($index.length && $window.scrollTop() > 0) { // 메인
  //         $search.addClass('is-sticky');
  //         $block.show();
  //       } else {
  //         $search.removeClass('is-sticky');
  //         $block.hide();
  //       }
  //     }
  //   } else { // 피씨
  //     if ($index.length && $window.scrollTop() > searchOffsetTop - $('.ncc-header').find('.ncc-lnb-wrap').outerHeight()) { // 메인
  //       $search.addClass('is-sticky');
  //       $block.show();
  //     } else {
  //       $search.removeClass('is-sticky');
  //       $block.hide();
  //     }
  //   }
  // }).trigger('scroll');
}

// 검색 페이지 이동
function runSearch (keyword) {
  const keywordTrim = keyword.trim().replace(/(<([^>]+)>)/ig, '');
  const index = cookieArray.indexOf(keywordTrim);

  if (index >= 0) cookieArray.splice(index, 1);

  cookieArray.unshift(keywordTrim);
  setCookie(serviceCookie, cookieArray.slice(0, 5).join(','));

  if(window.dataLayer){
    window.dataLayer.push({ 'event': 'inguidesearch', 'inguidequery': keyword });
  }

  location.href = `search#field=${getHash().field || 'guide_name,content'}&keyword=${keywordTrim}`;
}
